import { render, staticRenderFns } from "./PurchaseFlow.vue?vue&type=template&id=6adda6af"
import script from "./PurchaseFlow.vue?vue&type=script&lang=js"
export * from "./PurchaseFlow.vue?vue&type=script&lang=js"
import style0 from "./PurchaseFlow.vue?vue&type=style&index=0&id=6adda6af&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6adda6af')) {
      api.createRecord('6adda6af', component.options)
    } else {
      api.reload('6adda6af', component.options)
    }
    module.hot.accept("./PurchaseFlow.vue?vue&type=template&id=6adda6af", function () {
      api.rerender('6adda6af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PurchaseFlow/PurchaseFlow.vue"
export default component.exports